import { UserGroupIcon } from "@heroicons/react/24/solid";
import TextAreaHookForm from "../../../components/TextAreaHookForm";
import { useForm } from "react-hook-form";
import SubmitHookForm from "../../../components/SubmitHookForm";
import CancelButton from "../../../components/CancelButton";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import { useState } from "react";
import useRunScript from "./hooks/useRunScript";
import { useMutation } from "react-query";
import { toast } from "../../../components/toastNotification";
const ExecuteQueryTable = () => {
  const { mutateAsync: runScript } = useRunScript();
  const [saveModal, setSaveModal] = useState(false);
  const [result, setResult] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [newData, setNewData] = useState([]);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm("");
  const onSubmit = (data) => {
    setSaveModal(true);
    setNewData({ ...data });
  };
  const handleSave = () => {
    if (newData.script.trim() === "") {
      toast.fire("Executing Script failed", "Script is empty", "warning");
      setSaveModal(false);
      setResult(" The script is empty");
    } else {
      setConfirm(true);
      setSaveModal(false);
      mutate();
    }
  };
  const { mutate } = useMutation(() => runScript(newData), {
    onSuccess: (res) => {
      if (res.status === 200) {
        toast.fire("Success", "Script is successfully executed", "success");
        setResult(
          res.data.affectedRows +
            " Affected Row" +
            (res.data.affectedRows > 1 ? "s" : "")
        );
      } else {
        toast.fire(
          "Executing Script failed",
          "Server Error: Cannot execute script",
          "error"
        );
        setResult(" " + res.data.Message);
      }
      setConfirm(false);
    },
    onError: (error) => {
      toast.fire(
        "Executing Script failed",
        "Server Error: Cannot execute script",
        "error"
      );
      setResult(" " + error);
      setConfirm(false);
    },
  });
  const handleClear = () => {
    setValue("script", "");
    setResult("");
  };

  return (
    <div className="animate-fade-in-down bg-white box-shadow space-y-3 px-8 py-4 shadow-xl">
      <div className="flex gap-2 items-center">
        <div>
          <UserGroupIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
        </div>
        <div className="flex flex-col leading tight">
          <h3 className="text-xs font-medium text-gray-500">
            Utilities Module
          </h3>
          <h1 className="mr-auto font-bold text-primary text-md uppercase">
            EXECUTE QUERY
          </h1>
        </div>
      </div>
      <div className="borderSecondary my-2" />
      <div>
        <div className="px-4 py-2 space-y-2 border-l-2 border-primary box-shadow">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
              <div className="font-bold text-primary text-base">SCRIPT</div>
              <div className="flex justify-between gap-2">
                <SubmitHookForm
                  type="submit"
                  buttonText={confirm ? "Running..." : "Run"}
                />
                <CancelButton
                  buttonText="Clear"
                  type="button"
                  onClick={() => handleClear()}
                />
              </div>
            </div>

            <div className="bg-bgDB py-4 space-y-4 border-gray-700">
              <TextAreaHookForm
                secondDiv="grid grid-cols-1"
                name="script"
                label=""
                rows="12"
                type="text"
                placeholder=""
                className="text-lg sm:text-lg border-2 border-gray-200"
                register={register("script", {})}
              />
            </div>
          </form>
        </div>
        <div className="px-4 py-4 space-y-4 border-l-2 border-quinary box-shadow">
          <span>Result: {result}</span>
        </div>
        <ConfirmBoxModal
          ModalTitle={"Execute Query"}
          qConfirmation={`Are you sure you want to execute this script?`}
          isOpen={saveModal}
          onClose={() => setSaveModal(false)}
          onClickFunction={() => {
            handleSave();
          }}
        />
      </div>
    </div>
  );
};

export default ExecuteQueryTable;
